import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Persona, PersonaSize, ContextualMenu } from '@fluentui/react';
import { useQuery, useMutation } from '@apollo/client';
import { ME } from '../../graphql/queries';
import { LOGOUT } from '../../graphql/mutations';

const UserAvatarButton: React.FC = () => {
  const [isMenuVisible, setIsMenuVisible] = React.useState(false);
  const navigate = useNavigate();
  const { data } = useQuery(ME);
  const user = data?.me;
  const buttonRef = useRef<HTMLSpanElement>(null); // Изменён тип на HTMLSpanElement
  const [logout] = useMutation(LOGOUT);

  if (!user) return null;

  const handleMouseEnter = () => {
    setIsMenuVisible(true);
  };

  const handleMouseLeave = () => {
    setIsMenuVisible(false);
  };

  const handleAccountClick = () => {
    navigate('/AccountPage');
    setIsMenuVisible(false);
  };

  const handleLogoutClick = async () => {
    try {
      await logout(); // ✅ Отправляем запрос на сервер
    } catch (err) {
      console.error('Ошибка при выходе:', err);
    } finally {
    localStorage.removeItem('token');
    navigate('/Home');
    setIsMenuVisible(false);
    window.location.reload();
    }
  };

  return (
    <span
      ref={buttonRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ cursor: 'pointer', display: 'inline-block' }}
    >
      <Persona
        text={user.username}
        secondaryText={user.email}
        size={PersonaSize.size40}
        imageUrl={user.avatar || undefined}
        showSecondaryText
      />

      {isMenuVisible && (
        <ContextualMenu
          target={buttonRef as React.RefObject<Element>} // Явно приводим тип
          shouldFocusOnMount={true}
          onDismiss={handleMouseLeave}
          items={[
            {
              key: 'account',
              text: 'Аккаунт',
              iconProps: { iconName: 'Contact' },
              onClick: handleAccountClick,
            },
            {
              key: 'logout',
              text: 'Выйти',
              iconProps: { iconName: 'SignOut' },
              onClick: handleLogoutClick,
            },
          ]}
        />
      )}
    </span>
  );
};

export default UserAvatarButton;